import demographySegmentMap from "./segment-map";
function getSegments() {
    return window?.ALMA?.dmp && typeof window.ALMA.dmp.segments === "function"
        ? window.ALMA.dmp.segments()
        : [];
}
function mapSegment(table, segmentId) {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(table)) {
        if (Object.prototype.hasOwnProperty.call(value, segmentId)) {
            return [key, value[segmentId]];
        }
    }
    return null;
}
function getBrowserSegments() {
    const segments = getSegments();
    const kvs = {};
    segments.forEach((s) => {
        const map = mapSegment(demographySegmentMap, s);
        if (map && map[0] && map[1]) {
            kvs[map[0]] = [map[1].toString(10)];
        }
    });
    return kvs;
}
export default getBrowserSegments;
//# sourceMappingURL=dmp-segments.js.map